/**
 * ******************************************************
 * Copyright (C) 2020 VMware, Inc. All rights reserved.
 * *******************************************************
 *
 * @format
 */


export abstract class ForeignCertService {
   public abstract displayCert(url: string);
}
